import React, { useContext } from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { CheckInDeskIcon, PencilIcon } from 'assets/icons'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import PageActions from 'src/components/PageActions'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeActions = () => {
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)

   if (!initiative?.currentUserCanEdit) {
      return null
   }

   return (
      <PageActions
         editMenuOptions={
            <>
               {initiative.class === 'event' && (
                  <Link to={`${match.url}/checkin`}>
                     <ListMenuButton
                        name="Check-in Desk"
                        description={`Tool for checking in ${initiative.type.nameSingular} Attendees`}
                        icon={(
                           <CheckInDeskIcon
                              width="18px"
                              height="18px"
                              color="#aaa"
                           />
                        )}
                     />
                  </Link>
               )}
               <Link to={`${match.url}/settings`}>
                  <ListMenuButton
                     name={`${initiative.type.nameSingular} Info & Settings`}
                     description={`Edit the settings for this ${initiative.type.nameSingular}, including its layout and content`}
                     icon={(
                        <PencilIcon
                           width="16px"
                           height="16px"
                           color="#aaa"
                        />
                     )}
                  />
               </Link>
            </>
         }
      />
   )
}

export default InitiativeActions
